var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-card",class:{ card__flashing: this.flashing },style:(_vm.wrapStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }